export default __webpack_public_path__ + "static/media/plain-sticker-T.0521393b.png";